import { render, staticRenderFns } from "./OrderReturnReasonCode.vue?vue&type=template&id=754781c9"
import script from "./OrderReturnReasonCode.vue?vue&type=script&lang=js"
export * from "./OrderReturnReasonCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports